/**
 * Checks if a given string has double square brackets that makes it an action label
 * e.g. [[A1]]
 * @param {string} str - A string
 */
const isActionLabel = (str: string): boolean =>
  str.startsWith('[[') && str.endsWith(']]');

export default isActionLabel;
